@if (!isTest366()) {
  <app-progress-indicator [page]="Page.measuringDevice" />
}

<app-discount-banner
  [centered]="true"
  [topMargin]="true"
  [bottomMargin]="!isOuraFlow"
  [isTest366]="isTest366()"
/>
@if (isTest366()) {
  <app-oura-entrance (ouraSelected)="onOuraSelected($event)" />
} @else if (isOuraFlow) {
  <div class="ouraPage ouraPage___light">
    <div class="registrationBox" id="oura-page" [@fadeAnimation]>
      <div class="page-title">
        {{ 'oura-page-title' | translate }}
      </div>
      <img
        datoImage
        [imgixWidth]="150"
        class="ouraPage__image"
        alt="ouraRing"
        src="https://www.datocms-assets.com/21281/1744119900-oura-ring.png"
      />
      <div class="ouraPage__text">
        {{ 'oura-page-text' | translate }}
      </div>
      <app-button
        uid="ouraPage__alreadyUsingOura__btn"
        class="ouraPage__button"
        color="purple"
        text="white"
        [label]="'btn-already-using-oura' | translate"
        (click)="onOuraSelected(true)"
      />
      <app-button
        uid="ouraPage__startUsingOura__btn"
        class="ouraPage__button"
        color="white"
        border="purple"
        text="purple"
        [label]="'btn-i-want-to-use-oura' | translate"
        (click)="onOuraSelected(false)"
      />
    </div>
  </div>
} @else {
  <div
    class="measuringDevice measuringDevice___light"
    [ngClass]="
      measuringDevices().length % 3
        ? 'measuringDevice___twoColumns'
        : 'measuringDevice___threeColumns'
    "
    [@fadeAnimation]
  >
    <div class="measuringDevice__wrapper">
      <h2 class="measuringDevice__title">
        {{ 'measuringDevice-page-title' | translate }}
      </h2>

      <p class="measuringDevice__subTitle">
        {{ 'txt-effectiveness-remains-the-same' | translate }}
      </p>

      @if (hasLoadedDevices) {
        <div class="measuringDevice__cardsWrapper">
          @for (measuringDevice of measuringDevices(); track measuringDevice) {
            <app-measuring-device-card
              [product]="measuringDevice"
              (deviceSelected)="onDeviceSelected($event)"
            />
          }
        </div>
      }

      <div class="accordion">
        <app-accordion>
          <accordion-item>
            <ng-template accordionHeader>
              {{ 'measuring-device-which-device-title' | translate }}
            </ng-template>
            <ng-template accordionContent>
              <div
                class="accordion__content"
                [innerHTML]="'txt-can-not-decide-section' | tmd"
              ></div>
              @for (measuringDevice of measuringDevices(); track measuringDevice) {
                <div
                  class="accordion__content"
                  [innerHTML]="'measuring-device-which-device--' + measuringDevice.key | tmd"
                ></div>
              }
            </ng-template>
          </accordion-item>
        </app-accordion>
      </div>
    </div>
  </div>
}
